<template>
<div class="privacy page">

    <topheader back="/" v-if="!wnd">
        <template v-slot:info>
            <span>{{$t('caption.privacy')}}</span>
        </template>
    </topheader>

    <div class="work">
        <div class="privacyText" v-if="locale == 'en'">
            <p>Effective date: May 06, 2025</p>

            <p>Snippity (“us”, “we”, or “our”) operates the https://snippity.app website (the “Service”).</p>

            <p>This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data. Our Privacy Policy for Snippity is managed through Free Privacy Policy.</p>

            <p>We use your data to provide and improve the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, accessible from https://snippity.app</p>

            <p>INFORMATION COLLECTION AND USE</p>
            <p>We collect several different types of information for various purposes to provide and improve our Service to you.</p>

            <p>Types of Data Collected</p>

            <p>Personal Data</p>
            <p>While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you (“Personal Data”). Personally identifiable information may include, but is not limited to:</p>

            <p>Cookies and Usage Data</p>

            <p>Usage Data</p>
            <p>We may also collect information how the Service is accessed and used (“Usage Data”). This Usage Data may include information such as your computer’s Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.</p>

            <p>Tracking & Cookies Data</p>

            <p>We use cookies and similar tracking technologies to track the activity on our Service and hold certain information.</p>

            <p>Cookies are files with small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Tracking technologies also used are beacons, tags, and scripts to collect and track information and to improve and analyze our Service.</p>

            <p>You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.</p>

            <p>Examples of Cookies we use:</p>

            <p>Session Cookies. We use Session Cookies to operate our Service.
                Preference Cookies. We use Preference Cookies to remember your preferences and various settings.
                Security Cookies. We use Security Cookies for security purposes.</p>

            <p>USE OF DATA</p>
            <p>Snippity uses the collected data for various purposes:
                <ul>

                    <li>To provide and maintain the Service</li>
                    <li>To notify you about changes to our Service</li>
                    <li>To allow you to participate in interactive features of our Service when you choose to do so</li>
                    <li>To provide customer care and support</li>
                    <li>To provide analysis or valuable information so that we can improve the Service</li>
                    <li>To monitor the usage of the Service</li>
                    <li>To detect, prevent and address technical issues</li>
                </ul>

            </p>

            <p>TRANSFER OF DATA</p>

            <p>Your information, including Personal Data, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction.</p>

            <p>If you are located outside United States and choose to provide information to us, please note that we transfer the data, including Personal Data, to United States and process it there.</p>

            <p>Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.</p>

            <p>Snippity will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of your data and other personal information.</p>

            <p>DISCLOSURE OF DATA</p>

            <p>Legal Requirements</p>
            <p>
                Snippity may disclose your Personal Data in the good faith belief that such action is necessary to:

                <ul>

                    <li>To comply with a legal obligation</li>
                    <li>To protect and defend the rights or property of Snippity</li>
                    <li>To prevent or investigate possible wrongdoing in connection with the Service</li>
                    <li>To protect the personal safety of users of the Service or the public</li>
                    <li>To protect against legal liability</li>
                </ul>
            </p>

            <p>SECURITY OF DATA</p>
            <p>The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.</p>

            <p>SERVICE PROVIDERS</p>
            <p>We may employ third party companies and individuals to facilitate our Service (“Service Providers”), to provide the Service on our behalf, to perform Service-related services or to assist us in analyzing how our Service is used.</p>

            <p>These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.</p>

            <p>LINKS TO OTHER SITES</p>
            <p>Our Service may contain links to other sites that are not operated by us. If you click on a third party link, you will be directed to that third party’s site. We strongly advise you to review the Privacy Policy of every site you visit.</p>

            <p>We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.</p>

        
            <p>CHANGES TO THIS PRIVACY POLICY</p>
            <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</p>

            <p>We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective and update the “effective date” at the top of this Privacy Policy.</p>

            <p>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>

            <p>CONTACT US</p>
            <p>If you have any questions about this Privacy Policy, please contact us:</p>

            <p>By email: <a href="mailto:support@snippity.app">support@snippity.app</a></p>
        </div>
        <div class="privacyText" v-if="locale == 'ru'">
            <p>Дата вступления в силу: 06 мая 2025 г.</p>

            <p>ИП Гришков Максим («Snippity») («мы», «нас» или «наш») управляет веб-сайтом https://snippity.app («Сервис»).</p>

            <p>Эта страница информирует вас о наших политиках в отношении сбора, использования и раскрытия персональных данных при использовании вами нашего Сервиса и о вариантах, которые вы связали с этими данными. Наша Политика конфиденциальности для Snippity управляется с помощью Бесплатной политики конфиденциальности.</p>

            <p>Мы используем ваши данные для предоставления и улучшения Сервиса. Используя Сервис, вы соглашаетесь на сбор и использование информации в соответствии с этой политикой. Если иное не определено в настоящей Политике конфиденциальности, термины, используемые в настоящей Политике конфиденциальности, имеют те же значения, что и в наших Условиях и положениях, доступных по адресу https://snippity.app</p>

            <p>СБОР И ИСПОЛЬЗОВАНИЕ ИНФОРМАЦИИ</p>
            <p>Мы собираем несколько различных типов информации для различных целей, чтобы предоставлять вам и улучшать наш Сервис.</p>

            <p>Типы собираемых данных</p>

            <p>Персональные данные</p>
            <p>При использовании нашего Сервиса мы можем попросить вас предоставить нам определенную персональную информацию, которая может быть использована для связи с вами или вашей идентификации («Персональные данные»). Персональная информация может включать, помимо прочего:</p>

            <p>Файлы cookie и данные об использовании</p>

            <p>Данные об использовании</p>
            <p>Мы также можем собирать информацию о том, как осуществляется доступ к Сервису и как он используется («Данные об использовании»). Эти данные об использовании могут включать в себя такую ​​информацию, как IP-адрес вашего компьютера (например, IP-адрес), тип браузера, версия браузера, страницы нашего Сервиса, которые вы посещаете, время и дата вашего посещения, время, проведенное на этих страницах, уникальные идентификаторы устройств и другие диагностические данные.</p>

            <p>Данные отслеживания и файлы cookie</p>

            <p>Мы используем файлы cookie и аналогичные технологии отслеживания для отслеживания активности на нашем Сервисе и хранения определенной информации.</p>

            <p>Файлы cookie — это файлы с небольшим объемом данных, которые могут включать анонимный уникальный идентификатор. Файлы cookie отправляются в ваш браузер с веб-сайта и хранятся на вашем устройстве. Технологии отслеживания также включают маяки, теги и скрипты для сбора и отслеживания информации, а также для улучшения и анализа нашего Сервиса.</p>

            <p>Вы можете указать своему браузеру отклонять все файлы cookie или сообщать об отправке файла cookie. Однако, если вы не принимаете файлы cookie, вы не сможете использовать некоторые части нашего Сервиса.</p>

            <p>Примеры файлов cookie, которые мы используем:</p>

            <p>Сессионные файлы cookie. Мы используем сеансовые файлы cookie для работы нашего Сервиса.
            Предпочтения файлов cookie. Мы используем предпочтения файлов cookie для запоминания ваших предпочтений и различных настроек.
            Безопасные файлы cookie. Мы используем безопасные файлы cookie в целях безопасности.</p>

            <p>ИСПОЛЬЗОВАНИЕ ДАННЫХ</p>
            <p>Snippity использует собранные данные для различных целей:
            <ul>

                <li>Для предоставления и обслуживания Сервиса</li>
                <li>Для уведомления вас об изменениях в нашем Сервисе</li>
                <li>Для предоставления вам возможности участвовать в интерактивных функциях нашего Сервиса, когда вы этого захотите</li>
                <li>Для предоставления обслуживания и поддержки клиентов</li>
                <li>Для предоставления анализа или ценной информации, чтобы мы могли улучшить Сервис</li>
                <li>Для мониторинга использования Сервиса</li>
                <li>Для обнаружения, предотвращения и решения технических проблем</li>
            </ul>

            </p>

            <p>ПЕРЕДАЧА ДАННЫХ</p>

            <p>Ваша информация, включая Персональные данные, может передаваться и храниться на компьютерах, расположенных за пределами вашего штата, провинции, страны или другой правительственной юрисдикции, где законы о защите данных могут отличаться от законов вашей юрисдикции.</p>

            <p>Если вы находитесь за пределами Соединенных Штатов и решили предоставить нам информацию, обратите внимание, что мы передаем данные, включая Персональные данные, в Соединенные Штаты и обрабатываем их там.</p>

            <p>Ваше согласие с настоящей Политикой конфиденциальности, сопровождаемое предоставлением вами такой информации, означает ваше согласие на такую ​​передачу.</p>

           <p>ИП Гришков Максим («Snippity») предпримет все разумно необходимые шаги для обеспечения безопасной обработки ваших данных в соответствии с настоящей Политикой конфиденциальности, и никакая передача ваших Персональных данных не будет осуществляться в организацию или страну, если не будут приняты адекватные меры контроля, включая безопасность ваших данных и другой личной информации.</p>

            <p>РАСКРЫТИЕ ДАННЫХ</p>

            <p>Юридические требования</p>
            <p>
            Snippity может раскрыть ваши Персональные данные, добросовестно полагая, что такие действия необходимы для:

            <ul>

            <li>Соблюдения юридического обязательства</li>
            <li>Защиты и отстаивания прав или собственности Snippity</li>
            <li>Предотвращения или расследования возможных правонарушений, связанных с Сервисом</li>
            <li>Защиты личной безопасности пользователей Сервиса или общественности</li>
            <li>Защиты от юридической ответственности</li>
            </ul>
            </p>

            <p>БЕЗОПАСНОСТЬ ДАННЫХ</p>
            <p>Безопасность ваших данных важна для нас, но помните, что ни один метод передачи через Интернет или метод электронного хранения не является на 100% безопасным. Хотя мы стремимся использовать коммерчески приемлемые средства для защиты ваших Персональных данных, мы не можем гарантировать их абсолютную безопасность.</p>

            <p>ПОСТАВЩИКИ УСЛУГ</p>
            <p>Мы можем нанимать сторонние компании и лиц для содействия нашему Сервису («Поставщики услуг»), для предоставления Сервиса от нашего имени, для выполнения услуг, связанных с Сервисом, или для оказания нам помощи в анализе того, как используется наш Сервис.</p>

            <p>Эти третьи лица имеют доступ к вашим Персональным данным только для выполнения этих задач от нашего имени и обязаны не раскрывать или не использовать их в каких-либо других целях.</p>

            <p>ССЫЛКИ НА ДРУГИЕ САЙТЫ</p>
            <p>Наш Сервис может содержать ссылки на другие сайты, которые не управляются нами. Если вы нажмете на ссылку третьего лица, вы будете перенаправлены на сайт этого третьего лица. Мы настоятельно рекомендуем вам ознакомиться с Политикой конфиденциальности каждого посещаемого вами сайта.</p>

            <p>Мы не контролируем и не несем ответственности за содержание, политику конфиденциальности или практику любых сторонних сайтов или сервисов.</p>

            <p>ИЗМЕНЕНИЯ В ЭТОЙ ПОЛИТИКИ КОНФИДЕНЦИАЛЬНОСТИ</p>
            <p>Мы можем время от времени обновлять нашу Политику конфиденциальности. Мы уведомим вас о любых изменениях, разместив новую Политику конфиденциальности на этой странице.</p>

            <p>Мы сообщим вам по электронной почте и/или заметным уведомлением в нашем Сервисе до того, как изменения вступят в силу, и обновим «дату вступления в силу» в верхней части этой Политики конфиденциальности.</p>

            <p>Вам рекомендуется периодически просматривать эту Политику конфиденциальности на предмет любых изменений. Изменения в настоящей Политике конфиденциальности вступают в силу с момента их публикации на этой странице.</p>

            <p>СВЯЖИТЕСЬ С НАМИ</p>
            <p>Если у вас есть вопросы по настоящей Политике конфиденциальности, свяжитесь с нами:</p>

            <p>По электронной почте: <a href="mailto:support@snippity.app">support@snippity.app</a></p>
        </div>
    </div>
</div>
</template>

<style lang="sass" scoped>
.work 
	padding-left: 3 * $r !important
	padding-right: 2 * $r !important
	
	.privacyText 
		max-width: 740px
		padding-bottom : 8 * $r
		p 
			margin-top : $r
</style>

<script>

import { mapState } from 'vuex';


export default {
    name: 'privacy',
    components: {},

    props : {
		wnd : Boolean
	},

    computed: mapState({
        auth : state => state.auth,
        locale : function(state){
            return this.locales[state.locale] ? state.locale : 'en'
        }
    }),

    data : function(){

        return {
            loading : false,
            locales : {en : true, ru : true}
        }

    },

    methods: {

    }
}
</script>
